module.exports = __webpack_public_path__ + "static/media/Pharmacy_elements.280e6d88.png";